var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 206.7 206.7",
    style: {
      enableBackground: "new 0 0 206.7 206.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "zoJYrG_00000075856607737895586520000013520210251854386320_"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 2048,
    height: 2048,
    id: "zoJYrG_00000020373387605792569550000009774805009864293773_",
    xlinkHref: "DD25E321AF031CFE.png",
    transform: "matrix(8.658071e-02 0 0 8.658071e-02 709.3434 170.4554)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "qhFwYJ_00000032616473332947210420000013282750621809394873_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103.2,193.8c49.6,0.1,90.3-40.5,90.5-90.1c0.2-49.7-40.5-90.7-90.3-90.7C53.9,12.9,13.1,53.4,12.9,103 C12.7,152.7,53.5,193.7,103.2,193.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.2,193.8c-49.7-0.1-90.5-41-90.3-90.8c0.2-49.6,41-90.1,90.5-90.1c49.8,0.1,90.5,41,90.3,90.7 C193.6,153.3,152.8,193.8,103.2,193.8z M147.2,103.6c-0.2,14-5.8,24.8-15.6,33.5c-14.1,12.5-39.3,13.5-52.3,2.7 c-3.4-2.8-8.9-1.6-11.3,2c-2.2,3.3-1.2,6.9,2.8,9.7c28.4,20.3,70.1,9,85-23.5c3.4-7.5,4.8-15.9,7.4-24.6c2.4,0,5.8,0,10.1,0 c-6.5-9.7-12.4-18.7-18.8-28.2c-6.3,9.5-12.3,18.6-18.9,28.3C140,103.6,143.3,103.6,147.2,103.6z M71.2,102.7c-4.8,0-8.3,0-11.8,0 c0.3-14.6,6.3-25.9,17.2-34.5c13.7-10.9,37.2-11.9,49.5-2.4c4.5,3.5,9.5,3.1,12.4-0.9c2.6-3.6,1.2-7.2-3.8-10.5 C107.9,36.7,71.1,45,54,72.5c-5.8,9.3-8.6,19.4-9.2,30.7c-3.7,0-7.1,0-11.4,0c6.4,9.7,12.4,18.6,18.8,28.2 C58.5,121.8,64.5,112.9,71.2,102.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M147.2,103.6c-3.9,0-7.2,0-11.6,0c6.5-9.8,12.5-18.8,18.9-28.3c6.4,9.5,12.3,18.5,18.8,28.2 c-4.3,0-7.7,0-10.1,0c-2.6,8.7-4,17.1-7.4,24.6c-14.9,32.5-56.6,43.8-85,23.5c-4-2.9-5.1-6.5-2.8-9.7c2.5-3.6,7.9-4.9,11.3-2 c13,10.9,38.2,9.8,52.3-2.7C141.5,128.4,147.1,117.6,147.2,103.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.2,102.7c-6.8,10.1-12.7,19.1-19.1,28.6c-6.4-9.5-12.3-18.5-18.8-28.2c4.3,0,7.7,0,11.4,0 c0.5-11.3,3.4-21.4,9.2-30.7c17.1-27.5,53.9-35.8,80.8-18.2c5,3.3,6.3,7,3.8,10.5c-2.9,4-7.9,4.4-12.4,0.9 c-12.3-9.4-35.8-8.4-49.5,2.4c-10.9,8.6-16.9,19.9-17.2,34.5C63,102.7,66.4,102.7,71.2,102.7z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOs);
export default __webpack_public_path__ + "static/media/os.d6be46b0ff06def359ea14e25b60123d.svg";
export { ForwardRef as ReactComponent };